/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum AttachmentScope {
  DynamicForm = 'dynamicForm',
  WorkPackage = 'workPackage',
  WorkPackageReport = 'workPackageReport',
  Template = 'template',
  EffectiveLaborCost = 'effectiveLaborCost',
  EffectiveBasicCost = 'effectiveBasicCost',
  EffectiveRevenue = 'effectiveRevenue',
  Project = 'project',
  User = 'user',
  ApplicationIcon = 'applicationIcon',
  ApplicationLogo = 'applicationLogo',
  ApplicationLoginLogo = 'applicationLoginLogo'
}
